import { adminMenu } from "./admin-menu";
import { facultyMenu } from "./faculty-menu";
import MenuItem from "./menuItem";
import { useUserType } from "../../constants/Claims";


const SideBarMenu = () => {
    
    const userType = useUserType();
    const adminMenuToUse = userType === "FACULTY" ? facultyMenu : adminMenu;
    
    return (
        <div className="sidebar-menu">
            <ul className="menu">
                <li className="sidebar-title">Menu</li>
                {adminMenuToUse.map((item, index) => {
                    return (
                        <MenuItem
                            item={item}
                            index={index}
                            key={"menu" + index}
                        />
                    );
                })}
            </ul>
        </div>
    );
};
export default SideBarMenu;
